import InternalApi from "../axios/internalApi";

export const getGlobalPrivacyPolicy = async () => {
  try {
    const response = await InternalApi.get({
      server: "api/v1/",
      path: "privacy-policy"
    });
    return response;
  } catch (error) {
    console.error("Error fetching global privacy policy:", error);
    throw error;
  }
};

export const createGlobalPrivacyPolicy = async (privacyPolicyData) => {
  try {
    const response = await InternalApi.post({
      server: "api/v1/",
      path: "privacy-policy/admin/global",
    }, privacyPolicyData);
    return response.data;
  } catch (error) {
    console.error("Error creating global privacy policy:", error);
    throw error;
  }
};

export const updateGlobalPrivacyPolicy = async (privacyPolicyData) => {
  try {
    const response = await InternalApi.patch({
      server: "api/v1/",
      path: "privacy-policy/admin/global",
    }, privacyPolicyData);
    return response.data;
  } catch (error) {
    console.error("Error updating global privacy policy:", error);
    throw error;
  }
};
